import { shiftEditorViewState } from "..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateEndTimeShift", function updateEndTimeShift(newTime: Moment) {
    if (shiftEditorViewState().shift && newTime) {
        shiftEditorViewState().shift.endTime = newTime.clone();
    }
});